import { Button, Col, Modal, Row } from "react-bootstrap";
import honor from "../../assets/images/honor.png";
import user from "../../assets/images/user.png";
import { useTranslation } from "react-i18next";
import moment from "moment";
import shield from "../../assets/images/shield.png";
import pricing from "../../assets/json/pricing.json";
import { useEffect, useState } from "react";
import axios from "axios";
import FormData from "form-data";
import getPrice from "../Utils/PriceService";

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
function Honor({ closeModal, setHonorDone }: any) {
  const { t } = useTranslation();
  const [dates, setDates] = useState({
    releaseDate: "",
    returnDate: "",
  });
  const finalHandleClose = () => {
    closeModal();
    setFinalShow(false);
  };
  const [checked, setChecked] = useState(false);
  const [finalshow, setFinalShow] = useState(false);
  const [fields, setFields] = useState([]);
  const [healthFields, setHealthFields] = useState([]);
  const [honorData, setHonorData] = useState("");

  const closeHonorModal = () => {
    console.table(fields);
    sessionStorage.setItem("fields", JSON.stringify(fields));
    const honorArr: any[] = [];
    fields.map((e: any) =>
      // eslint-disable-next-line no-prototype-builtins
      e.hasOwnProperty("honor")
        ? e.honor == true
          ? honorArr.push(e.honor)
          : setHonorDone(false)
        : setHonorDone(false)
    );

    const HealthFormData = new FormData();
    HealthFormData.append("item", "honor");
    getPrice(HealthFormData, `honor`)
      .then((data: any) => {
        setHonorData(`${data}`);
      })
      .catch((error) => {
        setHonorData("");
      });

    if (honorArr.includes(true)) {
      setHonorDone(true);
      setFinalShow(true);
    }
  };

  const handleChangeInput = (id: any, event: any) => {
    //console.log(event.target);
    // setChecked(!checked);
    const newInputFields = fields.map((i: any, idx) => {
      // console.log(i);
      if (id === idx) {
        i[event.target.name] = !i.honor;
        const years = i.age;

        const {
          min: fmin,
          max: fmax,
          price: fprice,
        } = pricing[2].additional.first;
        const {
          min: smin,
          max: smax,
          price: sprice,
        } = pricing[2].additional.second;
        if (years >= fmin && years <= fmax) {
          i["price"] = fprice + i.price;
        }

        if (years >= smin && years <= smax) {
          i["price"] = sprice + i.price;
        }
      }
      return i;
    });

    setFields(newInputFields);

    console.log(fields);
    console.log(fields[0].honor);
    if (fields[0].honor == true) {
      sessionStorage.setItem("honor", "true");
    }
    //console.log(newInputFields);
    for (let i = 0; i < fields.length; i++) {
      if (fields[i].honor) {
        fields[i].honorValue = sessionStorage.getItem("honorvalue");
      } else {
        fields[i].honorValue = 0;
      }
    }
    sessionStorage.setItem("fields", JSON.stringify(fields));
  };
  useEffect(() => {
    const data = JSON.parse(sessionStorage.getItem("fields") || "");

    const nf = data.map((e: any) =>
      // eslint-disable-next-line no-prototype-builtins
      e.hasOwnProperty("honor") ? e : Object.assign(e, { honor: false })
    );
    setFields(nf);

    console.log(nf);

    const returnDate = sessionStorage.getItem("returndate");
    const releasedate = sessionStorage.getItem("releasedate");
    setDates({
      releaseDate: releasedate,
      returnDate: returnDate,
    });
  }, []);
  return (
    <>
      <Modal.Body>
        <div className="honorlogo">
          <img src={honor} alt="" />
          <div className="topsection">
            <h6>{t("anoHonor")}</h6>
            <p>{t("honorText")}</p>
          </div>
          <div className="date">
            {moment(dates.releaseDate).format("DD/MM/YYYY")} -{" "}
            {moment(dates.returnDate).format("DD/MM/YYYY")}
          </div>
          <h6>{t("whoTrust")}</h6>
          <div className="insured">
            <Row style={{ direction: "rtl" }}>
              {fields.map((e: any, i: number) => (
                <Col className="insured" key={i}>
                  <h6>
                    {t("insured")} {i + 1}
                  </h6>
                  <p>{e.date}</p>
                  <div className="hcheckbox">
                    <input
                      type="checkbox"
                      name="honor"
                      id=""
                      checked={e.honor}
                      onChange={(event: any) => {
                        handleChangeInput(i, event);
                      }}
                    />
                    <div
                      className="imgBordr"
                      style={
                        e.honor
                          ? { border: "2px solid red" }
                          : { border: "1px solid #ccc" }
                      }
                    >
                      <img src={user} alt="" />
                    </div>
                  </div>
                  <p>
                    {t("forEntire")}
                    <br />
                    {t("period")}
                  </p>
                </Col>
              ))}
            </Row>
          </div>
          <a href="#" onClick={closeModal}>
            {t("understoodBut")}
          </a>
          <br />
          <Button onClick={closeHonorModal}>{t("addCover")}</Button>
          <Modal
            show={finalshow}
            onHide={finalHandleClose}
            className="stepDmodal"
          >
            <Modal.Header closeButton></Modal.Header>
            <Modal.Body>
              <img src={shield} alt="" />
              <h6>{t("coverAdded")}</h6>
              <p>{t("policyUpdated")}</p>
              <p>$ {honorData}</p>
            </Modal.Body>
          </Modal>
        </div>
      </Modal.Body>
    </>
  );
}

export default Honor;
